import { FC } from 'react';
import { useForm, withForm } from 'react-bootstrap-formutil';
import PersonalInfo from 'components/forms/PersonalInfo';
import RealNameInfo from 'components/forms/RealNameInfo';
import { useGetAllCountry } from 'hooks/useGetCountryList';
import security from 'stores/security';
import values from 'stores/values';
import { CustomerInfoType, IdTypeEnum } from 'types/customer';
import Container from '../components/Container';

const BaseInfo: FC = () => {
    const { data: dataCountries } = useGetAllCountry();
    const {
        $params: { id_type, name_type, legal_residence_country, tax_residence_country, mask_id_no, country }
    } = useForm<CustomerInfoType>();
    const isSSN = id_type === IdTypeEnum.SSN_IDS;

    return (
        <Container>
            <h3 className="open-title mt-0">{__('PERSONAL INFORMATION')}</h3>
            <RealNameInfo nameType={name_type} idType={id_type} disabled />
            <PersonalInfo
                disabled
                isSSN={isSSN}
                legalResidenceCountry={legal_residence_country}
                taxResidenceCountry={tax_residence_country}
                idNumberProps={{
                    maskIdNo: mask_id_no,
                    idType: id_type
                }}
                hideHomeAddress
                countryProps={{
                    isSSN,
                    disabled: true,
                    countrySelectProps: {
                        extraCountryItems: dataCountries?.filter(item => item.country_code === country)
                    }
                }}
            />
        </Container>
    );
};

export default withForm(BaseInfo, {
    $defaultValues: () => {
        values.setShowProgressBar(false);

        return security.customerInfo;
    }
});
